// filepath: /Users/b/development/coding/gpt-debate-app/src/lib/analytics.js
import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase';

// User Events
export const trackLogin = (method) => {
  logEvent(analytics, 'login', { method });
};

export const trackSignUp = (method) => {
  logEvent(analytics, 'sign_up', { method });
};

export const trackAccountDeletion = () => {
  logEvent(analytics, 'delete_account');
};

// Debate Events
export const trackDebateStart = (topic) => {
  logEvent(analytics, 'debate_start', { topic });
};

export const trackDebateShare = (debateId) => {
  logEvent(analytics, 'debate_share', { debate_id: debateId });
};

export const trackDebateDelete = (debateId) => {
  logEvent(analytics, 'debate_delete', { debate_id: debateId });
};

// Subscription Events
export const trackSubscriptionStart = (plan, price) => {
  logEvent(analytics, 'begin_subscription', { 
    plan_name: plan,
    price: price
  });
};

export const trackSubscriptionCancel = (plan) => {
  logEvent(analytics, 'cancel_subscription', { 
    plan_name: plan
  });
};

// Feature Usage Events
export const trackFeatureUse = (featureName) => {
  logEvent(analytics, 'feature_use', { 
    feature_name: featureName
  });
};

export const trackError = (errorCode, errorMessage) => {
  logEvent(analytics, 'app_error', {
    error_code: errorCode,
    error_message: errorMessage
  });
};